import Vue from "vue";

export const appointmentLink = Vue.observable({ url: "" });

let loadPromise;

export function loadAppointmentLink() {
  if (!loadPromise) {
    const configUrl = `${
      process.env.BASE_URL
    }appointment-link.txt?v=${Date.now()}`;

    loadPromise = fetch(configUrl, { cache: "no-store" })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Appointment link file returned ${response.status}`);
        }

        return response.text();
      })
      .then(value => {
        const url = value.trim();
        const parsedUrl = new URL(url);

        if (parsedUrl.protocol !== "https:") {
          throw new Error("Appointment link must use HTTPS");
        }

        appointmentLink.url = url;
      })
      .catch(error => {
        console.error("Unable to load the appointment link.", error);
      });
  }

  return loadPromise;
}
